import { Expandable } from "@features/atoms/Expandable"
import { Appear } from "@features/motion/Appear"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Expandable List Item",
}

export default defineBlock("content/expandable-list-item", (props) => {
  return (
    <Appear className={cn("expandable-list-item w-full text-blue")}>
      <Expandable
        label={
          <EditableText store="expandable-list-item-label" className="type-body-s" placeholder="Enter label here" />
        }
        buttonClassName="border-b border-blue py-4"
        contentClassName="pb-5"
        icon={
          <svg className="size-3" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.000132918 6.26395V5.18395H11.4721V6.26395H0.000132918ZM5.20813 11.4719V-5.10216e-05H6.26413V11.4719H5.20813Z"
              fill="currentColor"
            />
          </svg>
        }
        iconOpen={
          <svg className="w-3 h-auto" viewBox="0 0 11 2" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.82609e-05 1.10382V-0.000175953H10.5601V1.10382H7.82609e-05Z" fill="currentColor" />
          </svg>
        }
      >
        <InnerBlocks
          allowedBlocks={["#inline"]}
          defaultBlocks={[["core/paragraph", { className: "is-style-body-small", placeholder: "Enter text here" }]]}
          className="w-full flex flex-col gap-3 [&_p]:!my-0"
        />
      </Expandable>
    </Appear>
  )
})
